<div class="p-3">
  <button type="button" class="btn itec-drawer-close" (click)="close()">
    <i class="material-icons md-18 align-middle">close</i>
  </button>
  <div class="drawer-header">
    <img src="assets/images/itechnovative-footer-logo.svg" class="menu-drawer-logo" alt="itechnovative innovation technology">
  </div>
  <ul class="nav flex-column">
    <li class="nav-item">
      <a [routerLink]="['/home']" routerLinkActive="router-link-active" class="d-inline-block btn btn-link nav-link text-white">
        <i class="material-icons md-18 align-middle">home</i>
        <span class="px-1 align-middle">{{'itechnov.menu.home.link' | translate}}</span>
      </a>
    </li>
    <li class="nav-item align-middle">
      <a [routerLink]="['/about-us']" routerLinkActive="router-link-active" class="d-inline-block btn btn-link nav-link text-white">
        <i class="material-icons md-18 align-middle">info</i>
        <span class="px-1 align-middle">{{'itechnov.menu.aboutus.link' | translate}}</span>
      </a>
    </li>
    <li class="nav-item">
      <a [routerLink]="['/contact-us']" routerLinkActive="router-link-active" class="d-inline-block btn btn-link nav-link text-white">
        <i class="material-icons md-18 align-middle">email</i>
        <span class="px-1 align-middle">{{'itechnov.menu.contactus.link' | translate}}</span>
      </a>
    </li>
  </ul>
  <div>
    <p class="navbar-text pt-5">
      <a class="fa-stack fa-lg itec-social-icon" href="https://www.linkedin.com/company/itechnovative" target="_blank">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-linkedin fa-stack-1x fa-inverse"></i>
      </a>
      <a class="fa-stack fa-lg itec-social-icon" href="https://www.facebook.com/Itechnovative-Limited-1101620116545638/?view_public_for=1101620116545638"
        target="_blank">
        <i class="fa fa-circle 	fa-stack-2x"></i>
        <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
      </a>
      <a class="fa-stack fa-lg itec-social-icon" href="https://twitter.com/itechnovative" target="_blank">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-twitter fa-stack-1x fa-inverse"></i>
      </a>
    </p>
  </div>
</div>
